import * as React from 'react';

import store from '@/redux/index';
import UIAddressPHP from '@/pages/containers/common/ui/address/index-php';

import { connect } from 'react-redux';
import { PickerBox } from '@/pages/components/picker';
import { types } from '@/redux/ui/address-php';
import * as ProductEditStore from '@/redux/pages/product-edit';

const Toast = require('react-toast-mobile');

class ProductPlace extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            countryList: [
                {
                    name: '中国',
                    value: '1'
                },
                {
                    name: '国外',
                    value: '2'
                }
            ], // 国籍列表
            modelCountry: props.country, // 国籍
            modelCountryName: props.country ? (props.country === '1' ? '中国' : '国外') : '', // 国籍名称
            addressName: props.addressInfo.province ? (props.addressInfo.province.name + props.addressInfo.city.name) : '', // 地区
            addressInfo: props.addressInfo.province ? props.addressInfo : {
                city: {},
                district: {},
                province: {}
            },
            modelArea: props.foreignAddress, // 地区
        };
    }

    public componentWillUnmount() { 
        store.dispatch({
            type: types.ADDRESS_HIDE
        });
    }

    public render() {
        const state = this.state;
        return(
            <section className="expert-edit place">
                <div className="ylk-edit-wrapper margin-0">
                    <div className="expert-edititem" onClick={() => this.selectCountry()}>
                        <div className="expert-editlabel">
                            国籍
                        </div>
                        <div className="expert-editgroup">
                            <p className={state.modelCountry ? 'active' : ''}>{ state.modelCountryName || '请选择'}</p>
                            <img className="icon-right" src={require('../../../../assets/images/choose.png')} alt="" />
                        </div>
                    </div>
                    {
                        state.modelCountry === '1' ?
                        <div className="expert-edititem" onClick={() => this.openAddressPanel()}>
                            <div className="expert-editlabel">
                                地区
                            </div>
                            <div className="expert-editgroup">
                                <p className={state.addressName ? 'active' : ''}>{state.addressName || '请选择'}</p>
                                <img className="icon-right" src={require('../../../../assets/images/choose.png')} alt="" />
                            </div>
                        </div> : null
                    }
                    {
                        state.modelCountry === '2' ?
                        <div className="expert-edititem">
                            <div className="expert-editlabel">
                                地区
                            </div>
                            <div className="expert-editgroup">
                                <input type="text" placeholder="请填写" onChange={() => this.inputAction()} value={state.modelArea}/>
                            </div>
                        </div> : null
                    }
                </div>
                <div className="expert-editbottom">
                    <button className="btn-submit" onClick={() => this.confirmAction()}>确定</button>
                </div>
                <UIAddressPHP />
            </section>
        )
    }

    // 选择国籍
    private selectCountry() { 
        (PickerBox as any).open({
            data: [{
                displayValue(item: any) {
                    return item.name;
                },
                list: this.state.countryList,
            }],
            // 成功回调
            onConfrim: (data: any) => {
                this.setState({
                    modelCountry: data.value,
                    modelCountryName: data.name
                });
            }
        });
    }

    // 打开地址面板
    private openAddressPanel() {
        const that = this;
        store.dispatch({
            type: types.ADDRESS_SHOW,
            showData: {
                row: 2,
                init: that.state.addressInfo,
                onConfirm(r: any) {
                    that.setState({
                        addressName: r.province.name + r.city.name,
                        addressInfo: r
                    });
                }
            }
        });
    }
    
    // 确定
    private confirmAction() { 

        const state = this.state;
        if (state.modelCountry === '') {
            return Toast.T.notify('请选择国籍');
        }
        if (state.modelCountry === '1' && !state.addressInfo.province.id) { 
            return Toast.T.notify('请选择地区');
        }
        if (state.modelCountry === '2' && state.modelArea === '') { 
            return Toast.T.notify('请填写地区');
        }

        store.dispatch({
            type: ProductEditStore.types.CONCAT,
            concatData: {
                country: state.modelCountry,
                addressInfo: state.addressInfo,
                foreignAddress: state.modelArea
            }
        });

        this.props.history.goBack();

    }

    // 输入
    private inputAction() { 
        this.setState({
            modelArea: (event as any).target.value
        });
    }
}

const mapStateToProps = (state: any):ProductEditStore.IProductEditState => { 
    return {
        ...state.productEditReducers
    }
}

export default connect(mapStateToProps)(ProductPlace);